const en = {
  // Navbar
  "nav.visione": "The Vision",
  "nav.territorio": "The Territory",
  "nav.servizi": "Services",
  "nav.immobili": "Properties",
  "nav.contatti": "Contact",
  "nav.progetto": "The Project",

  // Hero
  "hero.tagline": "Every borgo has a story to preserve.\nEvery home can become the beginning of a new life.",
  "hero.cta": "Discover Properties",
  "hero.scroll": "Scroll",

  // Visione
  "visione.overline": "MY vision",
  "visione.title": "We tell stories of lands.",
  "visione.text": "The Marche region holds an extraordinary, quiet heritage: medieval borghi where time flows slowly, sun-drenched stone piazzas, narrow lanes that breathe centuries of history. Between the Adriatic sea and the Sibillini mountains, these golden hills preserve a quality of life the modern world has forgotten. We don't sell properties. We open doors to territories waiting to be discovered, to rhythms waiting to be reclaimed, to roots waiting to be built.",
  "visione.ines.name": "Ines Felicity Di Nallo",
  "visione.ines.role": "Licensed Real Estate Agent",
  "visione.ines.bio": "Licensed CCIAA Ancona (October 2025) — Economics degree, University of Bologna — Former Head of Meeting & Events, G Hotel Ancona — Expert in digital marketing and international relations. Fluent in Italian, English and Spanish.",
  "visione.ines.badge.license": "CCIAA Ancona",
  "visione.ines.badge.unibo": "Economics Degree",
  "visione.ines.badge.languages": "IT · EN · ES",

  // Territorio
  "territorio.overline": "The territory",
  "territorio.title": "Le Marche: where time slows\ndown and beauty is at home",
  "territorio.text": "A region that embraces sea, mountain and hillside within a few kilometres. The Riviera del Conero with its crystal-clear waters, medieval borghi like Castelfidardo guardians of craftsmanship and music, hills covered in vines and olive trees, a cuisine that tells centuries of farming wisdom. Le Marche remains a well-kept secret — the place where those seeking authentic beauty find a homeland.",
  "territorio.caption1": "Scalinata Storica - Corinaldo",
  "territorio.caption2": "Riviera del Conero",
  "territorio.caption3": "Rocca Roveresca - Mondavio",
  "territorio.caption4": "Marchigiani Hills",
  "territorio.keyword1": "sea",
  "territorio.keyword2": "historic borghi",
  "territorio.keyword3": "food & wine",

  // Servizi
  "servizi.overline": "What we do",
  "servizi.0.title": "We Tell the Story of the Land",
  "servizi.0.desc": "Historic borghi, local farms and hospitality venues are not just properties — they are stories worth preserving and sharing. We craft authentic narratives for each place, highlighting its identity, history and potential, to attract those seeking not just a home, but a way of life.",
  "servizi.0.step1": "Listening to the story and identity of each place",
  "servizi.0.step2": "Showcasing borghi, farmhouses and agricultural estates",
  "servizi.0.step3": "Authentic storytelling for local hospitality venues",
  "servizi.0.step4": "Market positioning through a narrative that stands out",
  "servizi.title": "A bespoke service,\nnot a price list.",
  "servizi.1.title": "Historic Borgo Sales",
  "servizi.1.desc": "Careful selection of properties in Marche's historic borghi: farmhouses, rural estates, period palaces, homes with genuine character and soul.",
  "servizi.2.title": "International Assistance",
  "servizi.2.desc": "Full consultancy in Italian, English and Spanish for international buyers. From search to signing, every step accompanied in your language.",
  "servizi.3.title": "Photography & Virtual Tours",
  "servizi.3.desc": "Professional photo shoots and 360° virtual tours to showcase each property with the visual quality it truly deserves.",
  "servizi.4.title": "Professional Network",
  "servizi.4.desc": "Access to a curated network of architects, interior designers, surveyors, notaries and legal specialists in property transactions.",

  // Immobili
  "immobili.overline": "Featured",
  "immobili.title": "Selected Properties",
  "immobili.cta": "Request information",
  "immobili.badge1": "Castelfidardo",
  "immobili.badge2": "Riviera del Conero",
  "immobili.badge3": "Osimo Hills",
  "immobili.prop1.title": "Restored farmhouse",
  "immobili.prop1.type": "Farmhouse · 240 sqm · Hill views",
  "immobili.prop2.title": "Historic residence in borgo",
  "immobili.prop2.type": "Period palazzo · 380 sqm · Historic centre",
  "immobili.prop3.title": "Panoramic villa on the Conero",
  "immobili.prop3.type": "Villa · 320 sqm · Sea views",

  // Per Chi
  "perchi.overline": "Who this is for",
  "perchi.title": "Every story deserves\nits own territory.",
  "perchi.1.title": "Families & Young Professionals",
  "perchi.1.desc": "Those seeking authentic quality of life, space to grow, borghi where human rhythms are still possible and beauty is an everyday companion.",
  "perchi.2.title": "International Buyers",
  "perchi.2.desc": "Europeans, Anglo-Saxons, Latin Americans enchanted by the real Italy: full support from search to key handover, in your language.",
  "perchi.3.title": "Property Investors",
  "perchi.3.desc": "Those focusing on prestigious properties, agritourisms, hospitality venues in a region with extraordinary and still largely untapped tourist potential.",

  // Contatti
  "contatti.overline": "Let's talk",
  "contatti.title": "Every great story begins\nwith a conversation.",
  "contatti.name": "Name",
  "contatti.email": "Email",
  "contatti.phone": "Phone",
  "contatti.message": "Message",
  "contatti.message.placeholder": "Tell us what you're looking for...",
  "contatti.submit": "Send message",
  "contatti.success": "Message sent! We'll be in touch soon.",
  "contatti.error": "An error occurred. Please try again.",
  "contatti.sede": "Castelfidardo (AN), Italy",
  "contatti.lingue": "Italiano · English · Español",
  "contatti.instagram": "@felicity.dinallo_",

  // Footer FSE+
  "footer.copyright": "© 2026 Marche Casa. All rights reserved.",
  "footer.privacy": "Privacy Policy",
  "footer.progetto": "The Project",
  "footer.fse.title": "Project co-financed by the European Union",
  "footer.fse.text": "Project co-financed by the European Union — PR FSE+ 2021/27 Regione Marche — DGR n. 977 del 24/06/2024",
  "footer.fse.logo1": "Coesione Italia 2021-2027",
  "footer.fse.logo2": "Co-financed by the European Union",
  "footer.fse.logo3": "Italian Republic",
  "footer.fse.logo4": "Regione Marche",

  // Nav new pages
  "nav.borghi": "Borghi",
  "nav.blog": "Blog",

  // Footer new
  "footer.tagline": "Licensed real estate agent CCIAA Ancona.\nHistoric borghi of Marche · IT · EN · ES",
  "footer.guida": "Buying Guide",

  // Borghi section (home)
  "borghi.cta": "Discover the borgo",
  "borghi.viewAll": "View all borghi",

  // Borghi page
  "borghi.overline": "The borghi of Marche",
  "borghi.title": "Every borgo is a world\nwaiting to be discovered.",
  "borghi.intro": "Marche is an archipelago of medieval borghi, each with its own identity, its own story, its own character. From the Conero coast to the inland hills, every village preserves a unique heritage of architecture, craftsmanship and authentic flavours.",
  "borghi.filter.tutti": "All",
  "borghi.filter.mare": "Seaside",
  "borghi.filter.collina": "Hills",
  "borghi.filter.entroterra": "Inland",
  "borghi.zona.mare": "Seaside",
  "borghi.zona.collina": "Hills",
  "borghi.zona.entroterra": "Inland",
  "borghi.scopri": "Discover the borgo",
  "borghi.immobili.overline": "Selected properties",
  "borghi.immobili.title": "A property for every borgo.",
  "borghi.immobili.vedi": "View all properties",
  "borghi.cta.overline": "Start your search",
  "borghi.cta.title": "Do you have a borgo in mind?",
  "borghi.cta.text": "Tell us where you'd like to live and we'll help you find the right home in that territory.",
  "borghi.cta.btn": "Contact us",

  // Borgo detail
  "borgo.storia": "History & identity",
  "borgo.storia.title": "Discover {{name}}",
  "borgo.immobili.overline": "Properties in this borgo",
  "borgo.immobili.title": "Properties in {{name}}",
  "borgo.cta.title": "Want to live in {{name}}?",
  "borgo.cta.text": "Contact us to discover real estate opportunities in this borgo and surroundings.",
  "borgo.cta.btn": "Request information",

  // Immobili page
  "immobili.page.overline": "Property catalogue",
  "immobili.page.title": "Selected properties\nin the Marche borghi.",
  "immobili.filter.tipologia": "Type",
  "immobili.filter.target": "For whom",
  "immobili.filter.borgo": "Borgo",
  "immobili.filter.tutti": "All",
  "immobili.filter.rustico": "Rustic",
  "immobili.filter.palazzo": "Palazzo",
  "immobili.filter.villa": "Villa",
  "immobili.filter.casale": "Farmhouse",
  "immobili.filter.prima-casa": "Primary home",
  "immobili.filter.investimento": "Investment",
  "immobili.filter.turistico": "Tourism",
  "immobili.risultati": "properties found",
  "immobili.locali": "rooms",
  "immobili.dettagli": "View details",
  "immobili.nessun": "No properties found with the selected filters.",

  // Immobile detail
  "immobile.mq": "Area",
  "immobile.locali": "Rooms",
  "immobile.piano": "Floor",
  "immobile.stato": "Condition",
  "immobile.descrizione": "Description",
  "immobile.form.title": "Request information",
  "immobile.form.subtitle": "Fill in the form and we'll reply within 24 hours.",
  "immobile.altri.title": "More properties in {{borgo}}",

  // Blog
  "blog.overline": "Stories & insights",
  "blog.title": "The Marche Casa\nblog.",
  "blog.filter.tutti": "All",
  "blog.leggi": "Read article",
  "blog.correlati": "Related articles",
  "blog.borghi.correlati": "Related borghi",
  "blog.sidebar.cta.title": "Looking for a home in Marche?",
  "blog.sidebar.cta.text": "We're here to help you find the perfect property in your dream borgo.",
  "blog.sidebar.cta.btn": "Contact us",

  // Servizi page
  "servizi.page.title": "A bespoke service\nfor every story.",
  "servizi.page.intro": "We're not a traditional agency. Every client is a unique story, every property is a territory to be told. Our approach is personal, attentive, trilingual.",
  "servizi.1.step1": "Needs and budget analysis",
  "servizi.1.step2": "Careful property selection",
  "servizi.1.step3": "Guided visits in the borghi",
  "servizi.1.step4": "Support through to deed signing",
  "servizi.2.step1": "Initial consultation in your language",
  "servizi.2.step2": "Bureaucratic assistance (tax code, bank account)",
  "servizi.2.step3": "Coordination with notary and legal counsel",
  "servizi.2.step4": "Post-purchase support",
  "servizi.3.step1": "Site visit and photo shoot planning",
  "servizi.3.step2": "Professional shoot with natural light",
  "servizi.3.step3": "360° virtual tour with immersive technology",
  "servizi.3.step4": "Delivery of materials optimised for web and print",
  "servizi.4.step1": "Assessment of specific needs",
  "servizi.4.step2": "Selection of the most suitable professional",
  "servizi.4.step3": "Coordination and supervision",
  "servizi.4.step4": "Follow-up and quality assurance",
  "servizi.cta": "Request this service",
  "servizi.processo.overline": "How we work",
  "servizi.processo.title": "Our process in 5 steps",
  "servizi.step1.title": "Listening",
  "servizi.step1.desc": "Understanding your needs, lifestyle and budget",
  "servizi.step2.title": "Search",
  "servizi.step2.desc": "Careful selection of the most suitable properties",
  "servizi.step3.title": "Visit",
  "servizi.step3.desc": "Guided tours in the borghi with territorial insights",
  "servizi.step4.title": "Offer",
  "servizi.step4.desc": "Support in negotiation and purchase offer",
  "servizi.step5.title": "Deed",
  "servizi.step5.desc": "Full assistance through to key handover",
  "servizi.cta.title": "Ready to start?",
  "servizi.cta.text": "Contact us for a free, no-obligation consultation. We're here to listen.",
  "servizi.cta.btn": "Book a consultation",

  // Contatti page
  "contatti.page.title": "Every great story begins\nwith a conversation.",
  "contatti.info.overline": "Where we are",
  "contatti.info.title": "Let's talk about your\nlife project.",
  "contatti.info.text": "Whether you're looking for a first home, an investment or planning your move to Marche, we're here to listen. We respond in Italian, English and Spanish.",
  "contatti.sede.label": "Location",
  "contatti.lingue.label": "Languages",
  "contatti.abilitazione.label": "Licence",
  "contatti.borgo.label": "Borgo of interest",
  "contatti.borgo.placeholder": "Select a borgo...",
  "contatti.borgo.altro": "Other / Not sure yet",
  "contatti.form.title": "Write to us",
  "contatti.form.subtitle": "We reply within 24 hours.",
  "contatti.success.title": "Message sent!",

  // Move to Marche
  "move.hero.title": "Your new life\nstarts here.",
  "move.hero.subtitle": "Marche: authentic quality of life, accessible prices, medieval borghi, sea and mountains. All in one region.",
  "move.hero.cta": "Discover how to move",
  "move.why.overline": "Why Marche",
  "move.why.title": "Italy's most\nauthentic region.",
  "move.why.text": "Marche offers everything you look for in Italy — beauty, history, gastronomy, sea — without the crowds and prices of Tuscany or Umbria. A still authentic region where quality of life is extraordinary and real estate opportunities are still accessible.",
  "move.stat.costo": "Average monthly cost of living",
  "move.stat.costa": "Of Adriatic coastline",
  "move.stat.roma": "From Rome by train",
  "move.stat.aeroporti": "Nearby international airports",
  "move.process.overline": "How it works",
  "move.process.title": "The purchase process\nfor non-residents.",
  "move.step1.title": "Tax Code (Codice Fiscale)",
  "move.step1.desc": "The first step is obtaining an Italian tax code, required for any transaction. It can be obtained at the Italian Consulate in your country or directly at the Agenzia delle Entrate in Italy.",
  "move.step2.title": "Bank Account",
  "move.step2.desc": "Opening an Italian bank account simplifies payments. Not mandatory but strongly recommended. Some banks allow opening even for non-residents.",
  "move.step3.title": "Purchase Offer",
  "move.step3.desc": "Once you've found the property, you sign a purchase offer with a deposit. This binds both parties to the sale.",
  "move.step4.title": "Preliminary Contract",
  "move.step4.desc": "The preliminary contract (compromesso) defines all terms of the sale. A second deposit is paid, usually 10-20% of the price.",
  "move.step5.title": "Notarial Deed",
  "move.step5.desc": "The final deed of sale is signed before a notary. The balance of the price is paid and the keys are handed over.",
  "move.faq.overline": "Frequently asked questions",
  "move.faq.title": "FAQ for foreign buyers",
  "move.faq.1.q": "Can foreigners buy property in Italy?",
  "move.faq.1.a": "Yes, EU citizens can purchase freely. Non-EU citizens can purchase if there is a reciprocity agreement between Italy and their country (almost always the case).",
  "move.faq.2.q": "How much does it cost to buy a home in Marche?",
  "move.faq.2.a": "Prices vary widely: from €80,000 for a rustic to renovate to €700,000+ for luxury villas. The average for a habitable property is between €150,000 and €350,000.",
  "move.faq.3.q": "What taxes are paid on purchase?",
  "move.faq.3.a": "For primary residence: 2% registration tax on cadastral value. For second home or non-residents: 9%. Plus fixed mortgage and cadastral taxes (€50 each).",
  "move.faq.4.q": "Is a notary required?",
  "move.faq.4.a": "Yes, in Italy a notarial deed is mandatory for property transfer. The notary is chosen by the buyer and their fees are borne by the buyer.",
  "move.faq.5.q": "Can I get a mortgage as a foreigner?",
  "move.faq.5.a": "Yes, Italian banks grant mortgages to non-residents too, usually up to 60-70% of the property value. Demonstrable income and good credit rating are required.",
  "move.cta.title": "Ready to take the big step?",
  "move.cta.text": "Contact us for a free consultation. We guide you through every stage of the process, in your language.",
  "move.cta.btn": "Start your journey",

  // Guida acquisto
  "guida.overline": "Complete guide",
  "guida.title": "Buying a home in Marche:\nthe complete guide.",
  "guida.intro": "From property search to deed signing: everything you need to know to buy a home in the Marche borghi, step by step. A guide designed for both Italians and international buyers.",
  "guida.step": "Step",
  "guida.step1.title": "Property search",
  "guida.step1.text": "The search begins by clearly defining your needs: property type, geographic area, budget, intended use. In Marche it's essential to visit the borghi in person to understand which territory resonates with your lifestyle. Every borgo has a different soul.",
  "guida.step2.title": "Visit & assessment",
  "guida.step2.text": "The visit is the most important moment. Beyond the property, we assess the borgo, services, local community, infrastructure. For properties to renovate, a site visit with a surveyor is essential to estimate intervention costs.",
  "guida.step3.title": "Purchase offer",
  "guida.step3.text": "Once you've found the right property, a written purchase offer is submitted with a deposit (usually 5-10% of the price). If accepted by the seller, both parties are bound. If the seller withdraws, they return double the deposit.",
  "guida.step4.title": "Notarial deed",
  "guida.step4.text": "The deed is the final act of sale, signed before a notary. The notary verifies the property's regularity, calculates taxes due and registers the transfer of ownership. The balance of the price is paid at this stage.",
  "guida.step5.title": "Key handover",
  "guida.step5.text": "After signing the deed, the keys are handed over and the property is officially yours. Utility transfers follow (electricity, gas, water) and, if necessary, registration with the municipal registry.",
  "guida.sidebar.cta.title": "Need help?",
  "guida.sidebar.cta.text": "We're here to guide you through every stage of the purchase process.",
  "guida.sidebar.cta.btn": "Contact us",
  "guida.sidebar.move.text": "Are you a foreigner wanting to buy in Marche? Read our dedicated guide.",
  "guida.sidebar.move.btn": "Move to Marche",
  "guida.indice": "Contents",

  // Progetto Modal
  "progetto.title": "The Project",

  // Partner page
  "partner.hero.overline": "OUR NETWORK",
  "partner.hero.title": "Partner Professionals",
  "partner.intro": "Buying a home in Italy, especially if you're coming from another country, means relying on people who truly know the territory, the rules and the technical details. That's why Discovering Marche works side by side with carefully selected professionals, able to guarantee transparency at every stage of the negotiation and quality at every stage of execution.",
  "partner.partner1.overline": "Legal & Notary Firm",
  "partner.partner1.title": "Studio Spanò & Marchionni — Lawyer & Notary, Fermo",
  "partner.partner1.desc": "Studio Spanò & Marchionni of Fermo supports Discovering Marche in the legal and notarial aspects of every property negotiation. Two key figures — the lawyer and the notary — guaranteeing full transparency of the operation: document verification, protection of all parties, management of legal steps through to the deed. Essential support especially for international clients, who are often unfamiliar with the Italian purchase process.",
  "partner.partner1.bullet1": "Cadastral and urban planning compliance verification",
  "partner.partner1.bullet2": "Assistance at every stage of negotiation, from offer to deed",
  "partner.partner1.bullet3": "Maximum transparency for Italian and international buyers",
  "partner.partner2.overline": "Construction Company",
  "partner.partner2.title": "Sparviero Srl — Construction Company, Camerano (AN)",
  "partner.partner2.details": "Company active since 2000, ISO 9001 certified, SOA RINA Cat. OG1 - Class III qualification. Extensive experience in green building, full renovations, historic building restoration, detached villas and civil and industrial construction.",
  "partner.partner2.desc": "Sparviero Srl is the construction company that guarantees the execution quality of projects managed by Discovering Marche. It has delivered top-tier interventions in hospitality facilities — including Numana Blu S.P.A. in Marcelli — and has collaborated on prestigious residential developments focused on energy efficiency and environmental sustainability.",
  "partner.partner2.bullet1": "Full renovations of rustic homes, farmhouses and period properties",
  "partner.partner2.bullet2": "New builds and turnkey detached villas",
  "partner.partner2.bullet3": "Green building, energy efficiency and eco-sustainable materials",
  "partner.trust.overline": "Why a partner network",
  "partner.trust.title": "The strength of a close-knit team.",
  "partner.trust.trasparenza.title": "Transparency",
  "partner.trust.trasparenza.desc": "No legal or bureaucratic surprises: every step is verified and shared.",
  "partner.trust.qualita.title": "Construction quality",
  "partner.trust.qualita.desc": "Certified and verifiable interventions, with artisan excellence standards.",
  "partner.trust.referente.title": "A single point of contact",
  "partner.trust.referente.desc": "Discovering Marche coordinates every professional for you, with no confused delegation.",
  "partner.trust.multilingua.title": "Multilingual assistance",
  "partner.trust.multilingua.desc": "The team also supports international clients in Italian, English and Spanish.",
  "partner.cta.title": "Want to know how we work with our partners on your project?",
  "partner.cta.text": "Tell us about your project and we'll explain how our network of professionals can support you at every stage.",
  "partner.cta.btn": "Tell us about your project",

  "progetto.sintesi.title": "Project Summary",
  "progetto.sintesi.text": "The Marche Casa project was developed within the Regione Marche FSE+ Regional Programme 2021-2027, with the objective of supporting employment and self-entrepreneurship in high economic potential sectors, including the real estate market and experiential tourism in historic borghi.",
  "progetto.obiettivi.title": "Objectives",
  "progetto.obiettivi.text": "Promote access to self-employment in strategic sectors for the Marche region. Enhance the historic and rural property heritage as a lever for sustainable economic development. Foster integration between tourism, culture and the real estate market in inland and coastal areas.",
  "progetto.risultati.title": "Expected Results",
  "progetto.risultati.text": "Creation of an individual real estate agency specialising in Marche's historic borghi. Development of a bilingual service to attract national and international buyers. Contribute to the revitalisation of Marche's borghi through qualified property mediation.",
  "progetto.close": "Close",
};

export default en;
